"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("../../../atoms/Icon"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var spacingInPx = {
  headerButton: {
    padding: {
      top: 20,
      right: 16,
      bottom: 0,
      left: 0
    }
  },
  headerTitle: {
    padding: {
      top: 16,
      right: 32,
      bottom: 16,
      left: 32
    }
  }
};

var buildHeaderContainerStyles = function buildHeaderContainerStyles(_ref) {
  var palette = _ref.theme.palette;
  return (0, _styledComponents.css)(["display:flow-root;background-color:", ";color:", ";"], palette.primary.dark, palette.primary.contrastText);
};

var buildHeaderButtonStyles = function buildHeaderButtonStyles(_ref2) {
  var _ref2$theme = _ref2.theme,
      typography = _ref2$theme.typography,
      palette = _ref2$theme.palette;
  return (0, _styledComponents.css)(["display:flow-root;padding:", " ", " ", " ", ";background-color:", ";color:", ";float:right;.MuiIcon-root{vertical-align:top;cursor:pointer;color:", ";}"], typography.pxToRem(spacingInPx.headerButton.padding.top), typography.pxToRem(spacingInPx.headerButton.padding.right), typography.pxToRem(spacingInPx.headerButton.padding.bottom), typography.pxToRem(spacingInPx.headerButton.padding.left), palette.primary.dark, palette.primary.contrastText, palette.common.white);
};

var buildHeaderTitleStyles = function buildHeaderTitleStyles(_ref3) {
  var typography = _ref3.theme.typography;
  var font = typography.h2;
  return (0, _styledComponents.css)(["padding-top:", ";padding-bottom:", ";padding-left:", ";text-align:center;font-family:", ";font-size:", ";line-height:", ";font-weight:", ";text-transform:", ";letter-spacing:", ";"], typography.pxToRem(spacingInPx.headerTitle.padding.top), typography.pxToRem(spacingInPx.headerTitle.padding.bottom), typography.pxToRem(spacingInPx.headerTitle.padding.left), font.fontFamily, font.fontSize, font.lineHeight, font.fontWeight, font.textTransform, font.letterSpacing);
};

var HeaderContainer = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "ModalHeader__HeaderContainer"
})(["", ""], buildHeaderContainerStyles);

var HeaderTitleContainer = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "ModalHeader__HeaderTitleContainer"
})(["", ""], buildHeaderTitleStyles);

var HeaderButtonContainer = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "ModalHeader__HeaderButtonContainer"
})(["", ""], buildHeaderButtonStyles);

var ModalHeader = function ModalHeader(_ref4) {
  var onClose = _ref4.onClose,
      children = _ref4.children;
  return _react["default"].createElement(HeaderContainer, null, _react["default"].createElement(HeaderButtonContainer, null, onClose && _react["default"].createElement(_Icon["default"], {
    color: "primary",
    prefix: "fas",
    icon: "times",
    onClick: onClose,
    fontSize: "large"
  })), _react["default"].createElement(HeaderTitleContainer, null, children));
};

ModalHeader.defaultProps = {};
var _default = ModalHeader;
exports["default"] = _default;